import { render, staticRenderFns } from "./board_type.vue?vue&type=template&id=7978fc6e&scoped=true"
import script from "./board_type.vue?vue&type=script&lang=js"
export * from "./board_type.vue?vue&type=script&lang=js"
import style0 from "./board_type.vue?vue&type=style&index=0&id=7978fc6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7978fc6e",
  null
  
)

export default component.exports